export enum UserManagementActionType {
  SelectAll = 'select_all',
  ExcludeUsers = 'exclude_users',
  SetRoleFilter = 'set_role_filter',
  SetSearchFilter = 'set_search_filter',
  SetRetentionStatusFilter = 'set_retention_status_filter',
  SetUsers = 'set_users',
  SetRetentionStatuses = 'set_retention_statuses',
  SetSelectedUsers = 'set_selected_users',
  SelectUsers = 'select_user',
  RemoveUsers = 'remove_users',
  UpdateUsers = 'update_users',
  Reset = 'set_reset',
  SetUserManagementFilters = 'set_user_management_filters',
}
